import { getReferrer } from 'web/src/shared/Auth'
import { getTZOffset } from '@mote/helpers'
import { REFERRER_KEY } from '@mote/helpers/constants'
import { useGenericRequestHandler } from '../../handlers/useGenericRequestHandler'

export const useLoginMutation = () => {
  return useGenericRequestHandler({
    route: `v1/i/signIn/IDPAuthCode`,
    method: 'POST',
    options: {
      shouldPropagate403: true,
      json: {
        identityProvider: 'google',
        [REFERRER_KEY]: getReferrer(),
        TZOffset: getTZOffset(),
        lastLoginHostname: window.location.hostname
      }
    }
  })
}
